/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useLoading } from '../../../../../presentation/contexts/loading'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import ITable from '../../../../../presentation/interfaces/table'
import TableList from '../../../../../presentation/pages/dashboard/tables/cadastre/list'
import { theme } from '../../../../../presentation/styles/theme'
import { makeStablishmentTables } from '../../../../usecases/stablishment-tables/load-stablishment-tables'

const initialData: ITable = {
  headerItems: [
    { label: 'Mesa', size: 0.5, component: 'Text' },
    { label: 'QR Code gerado', size: 4, component: 'Text' },
    { label: 'Ativo?', size: 1, component: 'Switch' },
    {
      label: 'Ações',
      size: 1,
      component: 'Actions',
      type: 'action',
    },
  ],
  items: [],
  actions: [
    { icon: 'edit', text: 'Editar', color: '#0172CB' },
  ],
  hasCheckbox: true,
  stylesOptions: {
    headerTitle: {
      color: theme.colors.blue,
      fontWeight: theme.font.medium,
      fontFamily: theme.font.inter,
      fontSize: theme.font.sizes.medium,
    },
  },
}

const MakeTableList = () => {
  const history = useHistory()
  const { me } = useMe()
  const { setHeader } = usePage()
  const { onSetLoading } = useLoading()
  const [data, setData] = useState<ITable>(initialData)
  const [filteredData, setFilteredData] = useState<ITable>(initialData)
  const [listUpdated, setListUpdated] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [canAddTable, setCanAddTable] = useState(true)
  const [tableAmountLimit, setTableAmountLimit] = useState(0)

  const goToEditor = (currentData: any = null) => {
    if (currentData) {
      history.push({
        pathname: '/dashboard/tables/editor',
        state: {
          items: [currentData.item],
          tablesAmount: data.items.length,
          tableAmountLimit,
        },
      })
    } else {
      history.push({
        pathname: '/dashboard/tables/editor',
        state: {
          items: null,
          tablesAmount: data.items.length,
          tableAmountLimit,
        },
      })
    }
  }

  const toggleSwitchField = async (stablishmentTable: any, field: string) => {
    const currentValue = stablishmentTable[field]
    const itemToSubmit = { isActive: !currentValue }

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      await makeStablishmentTables(stablishmentId).patch(stablishmentTable.id, itemToSubmit)
      setListUpdated((state) => !state)
    } catch (error) {
      // console.log(error)
    }
  }

  const formatDataToTable = (response: any) => {
    const tablesFormatted: any = []

    response.stablishmentTables.forEach((stablishmentTable: any) => {
      tablesFormatted.push({
        item: stablishmentTable,
        datas: [
          { value: stablishmentTable.name, parent: 'Mesa' },
          { value: stablishmentTable.qrcodeUrl ? 'SIM' : 'Não', parent: 'QR Code gerado' },
          {
            value: stablishmentTable.isActive,
            parent: 'Ativo?',
            handler: () => toggleSwitchField(stablishmentTable, 'isActive'),
          },
        ],
      })
    })

    const newData = { ...initialData }
    newData.items = tablesFormatted
    newData.actions = [
      {
        icon: 'edit',
        handler: goToEditor,
        text: 'Editar',
        color: '#0172CB',
        hoverColor: '#C8E7FF',
      },
    ]

    return newData
  }

  const handleSearchTable = async (value: string) => {
    setSearchTerm(String(value))
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeStablishmentTables(stablishmentId).loadList({ term: value })
      const filteredTable = { ...formatDataToTable(response) }
      setFilteredData(filteredTable)
    } catch (error) {
      // console.log(error)
    }
  }

  useEffect(() => {
    (
      async () => {
        setHeader({
          title: 'Mesas',
          goTo: null,
        })
        onSetLoading(true)
        if (!me) return
        const stablishmentId = me.stablishments[0].id
        const response = await makeStablishmentTables(stablishmentId).loadList()
        const newData = { ...formatDataToTable(response) }
        setData(newData)

        const tablesAmount = newData.items.length
        const maxTableAmount = me.stablishments[0]?.tableAmount ?? 0

        setTableAmountLimit(maxTableAmount)

        if (!me.customer.newTables && tablesAmount >= maxTableAmount) {
          setCanAddTable(false)
        }

        if (listUpdated) {
          setListUpdated((state) => !state)
        }
        onSetLoading(false)
      }
    )()
  }, [me, listUpdated])

  useEffect(() => {
    (
      async () => {
        setFilteredData(data)
      }
    )()
  }, [data])

  return (
    <TableList
      canAddTable={canAddTable}
      setSearchTerm={handleSearchTable}
      searchTerm={searchTerm}
      tableData={filteredData}
      goToEditor={goToEditor}
    />
  )
}

export default MakeTableList
